import { Contract2Fachbereich } from '../../mdqx-graphql-types';

export class Contract2FachbereichEntity {
    public static readonly GqlFields = 'contractId fachbereicheId id';

    public ContractId: number;
    public FachbereicheId: number;
    public Id: number;

    constructor(contract2FachbereichType?: Contract2Fachbereich | null) {
        if (
            contract2FachbereichType &&
            contract2FachbereichType.contractId != null &&
            contract2FachbereichType.fachbereicheId != null &&
            contract2FachbereichType.id != null
        ) {
        } else {
            console.error('received broken Contract2FachbereichType', contract2FachbereichType);
            throw Error();
        }
    }
}
